<template>
    <div>
        <breadcrumbs
            :title="'Pošte'"
            :breadcrumbs="breadcrumbs"
        ></breadcrumbs>
        <div class="ibox">
            <div class="ibox-title">
                <h5>Pošta: {{ naziv }}</h5>
            </div>
            <div class="ibox-content">
                <posta-forma
                    :disabled="false"
                    :id="id"
                    :modal="false"
                    :action="'edit'"
                    @returnData="setData"
                ></posta-forma>
            </div>
        </div>
    </div>
</template>

<script>
import Breadcrumbs from "../../../../components/breadcrumbs/Breadcrumbs";
import PostaForma from "./PostaForma";
export default {
    name: "PostaEdit",
    components: {
        PostaForma,
        Breadcrumbs
    },
    data(){
        return {
            id: this.$route.params.posta_id,
            breadcrumbs: [],
            naziv: ''
        }
    },
    methods: {
        setBreadcrumbs(){
            this.breadcrumbs = [
                {
                    path: '/postavke/poste',
                    name: 'Pošte'
                },
                {
                    path: '/postavke/poste/' + this.id,
                    name: 'Pošta: ' + this.naziv
                },
                {
                    path: '/postavke/poste/' + this.id,
                    name: 'Uredi poštu: ' + this.naziv
                }
            ]
        },
        setData( data ){
            console.log( data )
            this.naziv = data.mjesto ? ( data.postanski_broj + ' ' + data.mjesto ) : ''
            this.setBreadcrumbs()
        }
    }
};
</script>

<style scoped>

</style>
